import { TransformPluginConfigs } from './transform-plugin-configs';

/**
 * This function is used to evaluate the plugin configuration for the On-Screen Log Plugin.
 *
 * @remarks
 * The plugin is enabled via a URL query parameter 'osl'. If the query parameter is present, the plugin is enabled.
 */
export const addOnScreenLogPlugin: TransformPluginConfigs = (partialBuilderConfig, pluginConfigs) => {
  const ON_SCREEN_LOG_QUERY_PARAM_KEY = 'osl';
  // location is not set in node context, thus we make this optional
  const url = new URL(location.href);

  if (!url.searchParams.has(ON_SCREEN_LOG_QUERY_PARAM_KEY)) {
    return pluginConfigs;
  }

  return {
    ...pluginConfigs,
    'foundation.plugin.onScreenLog': { enabled: true },
  };
};
